module.exports = __webpack_public_path__ + "static/media/Poppins-BoldItalic-latinext.34ad495c.woff2";